import { createContext } from 'react'
import type { NativeApplyOpenArgs } from './NativeApplyModal.types'

export type NativeApplyModalContextValue = {
  openNativeApply: (args: NativeApplyOpenArgs) => void
  closeNativeApply: () => void
  isOpen: boolean
}

/**
 * Bare React context for the Native Apply modal.
 *
 * Lives in its own module (separate from `NativeApplyModalProvider`) so test infrastructure can
 * provide a no-op context value without transitively importing `NativeApplyModal` and its
 * `common/hooks` dependencies, which previously corrupted unrelated tests' `jest.mock` factories.
 */
export const NativeApplyModalReactContext = createContext<NativeApplyModalContextValue | null>(null)
